import React from 'react';

interface Stat {
    value: string;
    label: string;
}

interface PerformanceStatsProps {
    stats: Stat[];
    className?: string;
}

export const PerformanceStats: React.FC<PerformanceStatsProps> = ({
    stats,
    className = '',
}) => {
    return (
        <div className={`trader-stats ${className}`}>
            {stats.map((stat, index) => (
                <div key={index} className="trader-stat">
                    <div className="trader-stat-value">{stat.value}</div>
                    <div className="trader-stat-label">{stat.label}</div>
                </div>
            ))}
        </div>
    );
};

export default PerformanceStats;
